import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./tailwind.generated.css";
import "bootstrap-icons/font/bootstrap-icons.css";

// ✅ ADD THIS HERE (GLOBAL CONSOLE CONTROL)
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.warn = () => {};
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();